module.exports = __webpack_public_path__ + "static/media/4.65e55739.svg";